import { render, staticRenderFns } from "./CustomVselect.vue?vue&type=template&id=1ab6d728&scoped=true"
import script from "./CustomVselect.vue?vue&type=script&lang=js"
export * from "./CustomVselect.vue?vue&type=script&lang=js"
import style0 from "./CustomVselect.vue?vue&type=style&index=0&id=1ab6d728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab6d728",
  null
  
)

export default component.exports